import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-778c7bd4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 2 }
const _hoisted_2 = ["data-row-key", "onMouseenter"]
const _hoisted_3 = ["data-row-key", "onMouseenter"]
const _hoisted_4 = ["data-row-key", "onMouseenter"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "red" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "/", -1))
const _hoisted_9 = { class: "green" }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["onClick", "src"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { class: "ybtitle-tooltip" }
const _hoisted_14 = ["id", "onClick"]
const _hoisted_15 = { class: "ybtitle-tooltip" }
const _hoisted_16 = ["id", "onClick"]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createTextVNode("下载 ")
const _hoisted_19 = { class: "spotColor" }
const _hoisted_20 = {
  key: 0,
  class: "heightarr"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = ["src"]
const _hoisted_23 = {
  key: 1,
  class: "heightarr"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = ["src"]
const _hoisted_26 = {
  key: 0,
  class: "heightarr"
}
const _hoisted_27 = ["src"]
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 1,
  class: "heightarr"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = ["src"]
const _hoisted_32 = { style: {"margin":"0"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_ArrowUpOutlined = _resolveComponent("ArrowUpOutlined")!
  const _component_ArrowDownOutlined = _resolveComponent("ArrowDownOutlined")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_VerticalAlignBottomOutlined = _resolveComponent("VerticalAlignBottomOutlined")!
  const _component_CaretDownOutlined = _resolveComponent("CaretDownOutlined")!
  const _component_CaretRightOutlined = _resolveComponent("CaretRightOutlined")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createBlock(_component_a_table, {
    columns: _ctx.columns,
    "data-source": _ctx.data,
    class: _normalizeClass(_ctx.theme),
    bordered: _ctx.bordered,
    pagination: _ctx.pagination,
    "row-key": 'index',
    scroll: _ctx.scroll,
    "expanded-row-keys": _ctx.expandedRowKeys,
    customRow: _ctx.customRow,
    "row-class-name": _ctx.setRowClassName,
    "custom-cell": _ctx.handleClickRow,
    size: "small",
    onExpand: _ctx.onExpand,
    onChange: _ctx.onChange
  }, _createSlots({
    rankColor: _withCtx(({ record }) => [
      (record.index !== undefined)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(record.index === 0 ? 'rank-first' : record.index === 1 ? 'rank-second' : record.index === 2 ? 'rank-third' : '')
          }, _toDisplayString(record.index + 1), 3))
        : (record.rank !== undefined)
          ? (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(record.rank === 1 ? 'rank-first' : record.rank === 2 ? 'rank-second' : record.rank === 3 ? 'rank-third' : '')
            }, _toDisplayString(record.rank), 3))
          : (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(record.index || record.rank || '--'), 1))
    ]),
    name: _withCtx(({ text }) => [
      _createElementVNode("a", null, _toDisplayString(text), 1)
    ]),
    Index: _withCtx(({ index }) => [
      _createElementVNode("span", null, _toDisplayString(index + 1), 1)
    ]),
    bkName: _withCtx(({ text, record }) => [
      _createVNode(_component_a_tooltip, {
        title: text,
        placement: "top",
        "get-popup-container": trigger => trigger.parentNode,
        visible: _ctx.isBkNameTooltipVisible(record),
        onVisibleChange: visible => _ctx.handleBkNameTooltipVisible(visible, record),
        overlayClassName: "name-cell-tooltip"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref: _ctx.setBkNameCellRef,
            "data-row-key": record.index,
            class: "name-cell-text ellipsis",
            onMouseenter: ($event: any) => (_ctx.checkBkNameOverflow(record, text)),
            style: {"max-width":"120px"}
          }, _toDisplayString(text), 41, _hoisted_2)
        ]),
        _: 2
      }, 1032, ["title", "get-popup-container", "visible", "onVisibleChange"]),
      (record.labels && record.labels.length > 0)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(record.labels, (item) => {
            return (_openBlock(), _createBlock(_component_a_tag, {
              color: "#f50",
              key: item,
              style: {"margin":"4px 2px 0px 0px"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item), 1)
              ]),
              _: 2
            }, 1024))
          }), 128))
        : _createCommentVNode("", true)
    ]),
    stockName: _withCtx(({ text, record }) => [
      _createVNode(_component_a_tooltip, {
        title: text,
        placement: "top",
        "get-popup-container": trigger => trigger.parentNode,
        visible: _ctx.isNameTooltipVisible(record),
        onVisibleChange: visible => _ctx.handleNameTooltipVisible(visible, record),
        overlayClassName: "name-cell-tooltip"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref: _ctx.setNameCellRef,
            "data-row-key": record.symbol,
            class: "name-cell-text ellipsis",
            onMouseenter: ($event: any) => (_ctx.checkTextOverflow(record, text)),
            style: {"max-width":"85px"}
          }, _toDisplayString(text), 41, _hoisted_3)
        ]),
        _: 2
      }, 1032, ["title", "get-popup-container", "visible", "onVisibleChange"])
    ]),
    changeRank: _withCtx(({ text }) => [
      _createElementVNode("div", {
        style: _normalizeStyle(text > 0 ? 'color:red' : text < 0 ? 'color:green' : '')
      }, [
        _createElementVNode("span", null, _toDisplayString(text), 1),
        (text > 0)
          ? (_openBlock(), _createBlock(_component_ArrowUpOutlined, { key: 0 }))
          : (text < 0)
            ? (_openBlock(), _createBlock(_component_ArrowDownOutlined, { key: 1 }))
            : _createCommentVNode("", true)
      ], 4)
    ]),
    riseFirstGrpName: _withCtx(({ record }) => [
      _createVNode(_component_a_tooltip, {
        title: record?.riseFirstGrp?.name || '——',
        placement: "top",
        "get-popup-container": trigger => trigger.parentNode,
        visible: _ctx.isGrpNameTooltipVisible(record),
        onVisibleChange: visible => _ctx.handleGrpNameTooltipVisible(visible, record),
        overlayClassName: "name-cell-tooltip"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", {
            ref: _ctx.setGrpNameCellRef,
            "data-row-key": record.index,
            class: "name-cell-text ellipsis",
            onMouseenter: ($event: any) => (_ctx.checkGrpNameOverflow(record, record?.riseFirstGrp?.name)),
            style: {"max-width":"85px"}
          }, _toDisplayString(record?.riseFirstGrp && record?.riseFirstGrp?.name ? record?.riseFirstGrp?.name : '--'), 41, _hoisted_4)
        ]),
        _: 2
      }, 1032, ["title", "get-popup-container", "visible", "onVisibleChange"])
    ]),
    riseFirstGrpRise: _withCtx(({ record }) => [
      (record?.riseFirstGrp)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass([record.riseFirstGrp.pxChangeRate > 0 ? 'red' : record.riseFirstGrp.pxChangeRate < 0 ? 'green' : ''])
          }, _toDisplayString(record.riseFirstGrp.pxChangeRate != null ? (record.riseFirstGrp.pxChangeRate * 100).toFixed(2) + '%' : '——'), 3))
        : (_openBlock(), _createElementBlock("span", _hoisted_5, "——"))
    ]),
    riseAFall: _withCtx(({ record }) => [
      (record.riseCount != null && record.fallCount != null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, _toDisplayString(record.riseCount ? record.riseCount : 0), 1),
            _hoisted_8,
            _createElementVNode("span", _hoisted_9, _toDisplayString(record.fallCount ?
          record.fallCount : record.fallCount), 1)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_10, "--"))
    ]),
    pdf: _withCtx(({ text }) => [
      text
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            onClick: ($event: any) => (_ctx.openPdf(text)),
            src: require("@/assets/pdf.png"),
            style: {"cursor":"pointer"}
          }, null, 8, _hoisted_11))
        : (_openBlock(), _createElementBlock("span", _hoisted_12, "--"))
    ]),
    advice: _withCtx(({ text }) => [
      _createElementVNode("span", null, _toDisplayString(text ? text : '--'), 1)
    ]),
    ellipsis: _withCtx(({ record, text, index, column }) => [
      _createVNode(_component_a_popover, {
        placement: "topLeft",
        visible: _ctx.overflow[column.key + record.index],
        align: {
        offset: [0, 4]
      },
        "mouse-enter-delay": 0.4,
        overlayClassName: 'imitatetitletooltip',
        "get-popup-container": _ctx.getPopupContainer,
        onVisibleChange: ($event: any) => (_ctx.visibleChange($event, (column.key + record.index)))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_13, _toDisplayString(text), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", {
            class: "overflow",
            href: "javascript:void(0)",
            id: column.key + record.index,
            onClick: ($event: any) => (_ctx.showdrawer(record, column))
          }, _toDisplayString(text ? text : '—'), 9, _hoisted_14)
        ]),
        _: 2
      }, 1032, ["visible", "mouse-enter-delay", "get-popup-container", "onVisibleChange"])
    ]),
    link: _withCtx(({ record, text, index, column }) => [
      _createVNode(_component_a_popover, {
        placement: "topLeft",
        visible: _ctx.overflow[column.key + record.index],
        align: {
        offset: [0, 4]
      },
        "destroy-tooltip-on-hide": "",
        "mouse-enter-delay": 0.4,
        overlayClassName: 'imitatetitletooltip',
        "get-popup-container": _ctx.getPopupContainer,
        onVisibleChange: ($event: any) => (_ctx.visibleChange($event, (column.key + record.index)))
      }, {
        content: _withCtx(() => [
          _createElementVNode("div", _hoisted_15, _toDisplayString(text), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("a", {
            class: "overflow",
            id: column.key + record.index,
            href: "javascript:void(0)",
            onClick: ($event: any) => (_ctx.gotolink($event, record, column))
          }, _toDisplayString(text || '—'), 9, _hoisted_16)
        ]),
        _: 2
      }, 1032, ["visible", "mouse-enter-delay", "get-popup-container", "onVisibleChange"])
    ]),
    increase: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        class: _normalizeClass([text > 0 ? 'red' : text < 0 ? 'green' : ''])
      }, _toDisplayString(_ctx.getPencent(text)), 3)
    ]),
    nocolorincrease: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(_ctx.getPencent(text)), 5)
    ]),
    decimal: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(parseFloat(text).toString() !== 'NaN' ? (text || 0).toFixed(2) : '—'), 5)
    ]),
    decimal4: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(parseFloat(text).toString() !== 'NaN' ? (text || 0).toFixed(4) : '—'), 5)
    ]),
    peopleCount: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(_ctx.getNumber1(text)), 5)
    ]),
    peopleStockCount: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(_ctx.getNumber1(text*1000)), 5)
    ]),
    peopleCountFixed2: _withCtx(({ record, text }) => [
      _createElementVNode("span", {
        style: _normalizeStyle(_ctx.theme !== 'dark' ? 'color: #1d1d1d' : 'color: #D7D7DF')
      }, _toDisplayString(_ctx.getNumber2(text)), 5)
    ]),
    download: _withCtx(({ record, text, column }) => [
      _createElementVNode("a", {
        class: "download",
        onClick: ($event: any) => (_ctx.gotolink($event, record, column)),
        href: "javascript:;"
      }, [
        _createVNode(_component_VerticalAlignBottomOutlined),
        _hoisted_18
      ], 8, _hoisted_17)
    ]),
    peopleCountColorUpdate: _withCtx(({record, text }) => [
      _createElementVNode("span", {
        class: _normalizeClass([record.increase > 0 ? 'red' : record.increase < 0 ? 'green' : ''])
      }, _toDisplayString(_ctx.getNumberNoUnit2(text)), 3)
    ]),
    peopleCountColor: _withCtx(({record, text }) => [
      _createElementVNode("span", {
        class: _normalizeClass([record.increase > 0 ? 'red' : record.increase < 0 ? 'green' : ''])
      }, _toDisplayString(_ctx.getNumberNoUnit2(text)), 3)
    ]),
    mainPeopleCountColor: _withCtx(({record, text }) => [
      _createElementVNode("span", {
        class: _normalizeClass([text > 0 ? 'red' : text < 0 ? 'green' : ''])
      }, _toDisplayString(_ctx.getNumber(text)), 3)
    ]),
    spotColor: _withCtx(({ record, text }) => [
      _createElementVNode("div", _hoisted_19, [
        _createTextVNode(_toDisplayString(text || ''), 1),
        (record.color)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              style: _normalizeStyle({ background: record.color })
            }, null, 4))
          : _createCommentVNode("", true)
      ])
    ]),
    RLnocolorincrease: _withCtx(({ record, text, column }) => [
      (_ctx.theme !== 'dark')
        ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
            (record['height' + column.key] === 1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require('@/assets/top_light.png'),
                  alt: ""
                }, null, 8, _hoisted_21))
              : _createCommentVNode("", true),
            (record['height' + column.key] === 2)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/bottom_light.png'),
                  alt: ""
                }, null, 8, _hoisted_22))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_23, [
            (record['height' + column.key] === 1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require('@/assets/top_light.png'),
                  alt: ""
                }, null, 8, _hoisted_24))
              : _createCommentVNode("", true),
            (record['height' + column.key] === 2)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/bottom_dark.png'),
                  alt: ""
                }, null, 8, _hoisted_25))
              : _createCommentVNode("", true)
          ])),
      _createTextVNode(" " + _toDisplayString(parseFloat(text).toString() !== 'NaN' ? (text || 0).toFixed(2) : '—'), 1)
    ]),
    RLpeopleCount: _withCtx(({ record, text, column }) => [
      (_ctx.theme !== 'dark')
        ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
            (record['height' + column.key] === 1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require('@/assets/top_light.png'),
                  alt: ""
                }, null, 8, _hoisted_27))
              : _createCommentVNode("", true),
            (record['height' + column.key] === 2)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/bottom_light.png'),
                  alt: ""
                }, null, 8, _hoisted_28))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("span", _hoisted_29, [
            (record['height' + column.key] === 1)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: require('@/assets/top_light.png'),
                  alt: ""
                }, null, 8, _hoisted_30))
              : _createCommentVNode("", true),
            (record['height' + column.key] === 2)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/bottom_dark.png'),
                  alt: ""
                }, null, 8, _hoisted_31))
              : _createCommentVNode("", true)
          ])),
      _createElementVNode("span", null, _toDisplayString(_ctx.getNumber(text)), 1)
    ]),
    _: 2
  }, [
    (_ctx.expandedRowRender)
      ? {
          name: "expandedRowRender",
          fn: _withCtx(({ record }) => [
            _createElementVNode("p", _hoisted_32, _toDisplayString(record.description), 1)
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.expandedRowRender)
      ? {
          name: "expandIcon",
          fn: _withCtx((props) => [
            (props.expanded)
              ? (_openBlock(), _createBlock(_component_CaretDownOutlined, {
                  key: 0,
                  onClick: ($event: any) => (_ctx.clickexpandIcon(props))
                }, null, 8, ["onClick"]))
              : (_openBlock(), _createBlock(_component_CaretRightOutlined, {
                  key: 1,
                  onClick: ($event: any) => (_ctx.clickexpandIcon(props))
                }, null, 8, ["onClick"]))
          ]),
          key: "1"
        }
      : undefined
  ]), 1032, ["columns", "data-source", "class", "bordered", "pagination", "scroll", "expanded-row-keys", "customRow", "row-class-name", "custom-cell", "onExpand", "onChange"]))
}